import { type FC } from "react";
import { Card, CardContent, Typography, Stack, Box } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useDispatch, useSelector } from "src/store";
import { tokens } from "src/locales/tokens";
import { useTranslation } from "react-i18next";
import { useRouter } from "src/hooks/use-router";
import { createRoute } from "react-router-url-params";
import { paths } from "src/paths";
import toast from "react-hot-toast";
import { thunks } from "src/thunks/strategy-wizard";

interface CreateContentStrategyProps {
  instagramAccountId: string;
}

export const CreateContentStrategy: FC<CreateContentStrategyProps> = (
  props
) => {
  const { instagramAccountId } = props;
  const { isInitializing } = useSelector((state) => state.strategyWizard);
  const { t, i18n } = useTranslation();
  const router = useRouter();
  const dispatch = useDispatch();
  return (
    <>
      <Card
      // sx={{
      //   bgcolor: "var(--mui-palette-primary-main)",
      //   color: "var(--mui-palette-primary-contrastText)",
      // }}
      >
        <Box
          sx={{
            bgcolor: "var(--mui-palette-neutral-900)",
            borderRadius: "20px",
            color: "var(--mui-palette-common-white)",
            overflow: "hidden",
            position: "relative",
            p: { xs: "32px 24px", md: "64px 56px", lg: "50px 80px" },
          }}
        >
          <Box
            alt="Pulse"
            component="img"
            src="/assets/pulse.svg"
            sx={{
              top: 0,
              height: "auto",
              right: 0,
              position: "absolute",
              width: "900px",
              zIndex: 0,
              transform: "scaleX(-1)",
            }}
          />

          <CardContent
            sx={{
              height: "100%",
              padding: 4,
            }}
          >
            <Stack
              spacing={3}
              justifyContent={"center"}
              alignItems={"center"}
              alignContent={"center"}
            >
              <Typography variant="h5">Create a content strategy</Typography>
              <Typography variant="body2">
                Create a content strategy for the Instagram account
              </Typography>
              <Box>
                <LoadingButton
                  disabled={isInitializing}
                  loading={isInitializing}
                  size="large"
                  onClick={async () => {
                    const strategyId = await dispatch(
                      thunks.createStrategy(instagramAccountId, i18n.language)
                    );
                    if (strategyId) {
                      router.push(
                        createRoute(paths.strategy.brandDetails).link({
                          strategyId: strategyId,
                        })
                      );
                    } else {
                      toast.error(t(tokens.general.formError));
                    }
                  }}
                  variant="contained"
                  sx={{
                    minWidth: 200,
                    height: 56,
                  }}
                >
                  {t(tokens.landing.hero.button)}
                </LoadingButton>
              </Box>
            </Stack>
          </CardContent>
        </Box>
      </Card>
    </>
  );
};
